/* Present the product's own Judge.me reviews in the two Figma cards. */
if (!customElements.get('annais-review-cards')) {
  customElements.define('annais-review-cards', class extends HTMLElement {
    connectedCallback() {
      this.widget = document.getElementById(this.dataset.widget);
      if (!this.widget) return;
      this.update = () => {
        const reviews = Array.from(this.widget.querySelectorAll('.jdgm-rev')).filter(review => review.querySelector('.jdgm-rev__body')?.textContent.trim());
        Array.from(this.children).forEach((card, index) => {
          if (card.hasAttribute('data-custom-quote')) return;
          if (card.dataset.reviewResolved) return;
          const review = reviews[(Number(card.dataset.reviewSelection) || index + 1) - 1];
          if (!review) return;
          const quote = card.querySelector('blockquote');
          const author = card.querySelector('[data-review-author]');
          const stars = card.querySelector('[data-review-stars]');
          quote.textContent = `« ${review.querySelector('.jdgm-rev__body').textContent.trim()} »`;
          author.textContent = review.querySelector('.jdgm-rev__author')?.textContent.trim() || '';
          const score = Number(review.querySelector('.jdgm-rev__rating')?.getAttribute('data-score'));
          stars.textContent = score >= 1 && score <= 5 ? '★'.repeat(score) + '☆'.repeat(5 - score) : '';
          stars.setAttribute('aria-label', score ? `${score}/5` : '');
          card.hidden = false;
          card.dataset.reviewResolved = 'true';
        });
        if (Array.from(this.children).every(card => card.hasAttribute('data-custom-quote') || card.dataset.reviewResolved)) {
          // Keep the first two genuine reviews stable when the full widget is paginated.
          this.observer.disconnect();
        }
      };
      this.observer = new MutationObserver(this.update);
      this.observer.observe(this.widget, { childList: true, subtree: true });
      this.update();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
